import { render } from "./AttributeCharts.vue?vue&type=template&id=2676d630&scoped=true"
import script from "./AttributeCharts.vue?vue&type=script&lang=js"
export * from "./AttributeCharts.vue?vue&type=script&lang=js"

import "./AttributeCharts.vue?vue&type=style&index=0&id=2676d630&scoped=true&lang=css"
import "./AttributeCharts.vue?vue&type=style&index=1&id=2676d630&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2676d630"]])

export default __exports__